import React from 'react'
import { Provider } from 'react-redux'
import { store, persistor } from './stores/index'
import { PersistGate } from 'redux-persist/integration/react'

import Main from './containers/main/index'

const App = () => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Main />
            </PersistGate>
        </Provider>
    )
}

export default App



// WEBPACK FOOTER //
// ./src/App.js